<template>
  <div>
    <div class="row">
      <div class="col-md-12 mb-3">
        <button class="btn btn-success" @click="exportToExcel" style="white-space: nowrap">
          Exportar para Excel
        </button>
      </div>

      <!-- Filtro de Grupos Múltiplo -->
      <div class="col-md-6 mb-3">
        <div class="row">
          <div class="col-md-6">
            <label class="form-label"><strong>Filtrar por Grupos:</strong></label>
            <v-select v-model="gruposSelecionados" :options="grupos" multiple label="text" track-by="id"
              placeholder="Selecione os grupos..." :close-on-select="true">
              <template #no-options>
                {{ grupos.length === 0 ? 'Carregando grupos...' : 'Nenhum grupo encontrado' }}
              </template>
            </v-select>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-6">
            <button class="btn btn-primary mr-2" @click="filtrarPorGrupos" :disabled="gruposSelecionados.length === 0">
              Filtrar
            </button>
            <button class="btn btn-secondary" @click="limparFiltros">
              Limpar
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <base-crud :ref="'materiaisCrud'" crudName="Materiais" newText="Novo Material" :table="table" :columns="columns"
          :options="options" :endPoint="endPoint" :enableAdd="true" :enableEdit="true" :enableDelete="true"
          :enableView="true" :enableReset="false" :dataForm="dataForm" :extra="extra" @check="check">
        </base-crud>
      </div>
      <div v-if="isModalOpen" class="modal fade show" style="display: block" tabindex="-1">
        <div class="modal-dialog modal-xl modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Estoques</h5>
              <button type="button" class="close" @click="closeModal">
                &times;
              </button>
            </div>
            <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
              <div class="table-responsive" style="overflow-x: auto; white-space: nowrap">
                <table class="table table-bordered table-striped">
                  <thead class="text-center thead-dark">
                    <tr>
                      <th style="min-width: 250px">Material</th>
                      <th style="min-width: 150px">Fabricante</th>
                      <th style="min-width: 100px">Lote</th>
                      <th style="min-width: 80px">Estoque</th>
                      <th style="min-width: 100px">Validade</th>
                    </tr>
                  </thead>
                  <tbody v-for="estoque in estoques" :key="estoque.id || 'separator'">
                    <!-- Linha separadora de vencidos -->
                    <tr v-if="estoque.isVencidosSeparator" class="bg-danger text-white font-weight-bold">
                      <td colspan="2" class="text-center">
                        <i class="fas fa-exclamation-triangle"></i> VENCIDOS
                      </td>
                      <td class="text-center">-</td>
                      <td class="text-center">{{ estoque.quantidade }}</td>
                      <td class="text-center">-</td>
                    </tr>

                    <!-- Linha normal de estoque -->
                    <tr v-else :class="{ 'table-danger': estoque.isVencido }">
                      <td style="
                          white-space: normal;
                          word-wrap: break-word;
                          max-width: 250px;
                        ">
                        {{ estoque.material.nome }}
                      </td>
                      <td class="text-center">
                        {{
                          estoque.fabricante
                            ? estoque.fabricante.nome_fantasia
                            : "Indisponível"
                        }}
                      </td>
                      <td class="text-center">{{ estoque.lote }}</td>
                      <td class="text-center">{{ estoque.quantidade }}</td>
                      <td class="text-center">{{ estoque.validade_f }}</td>
                    </tr>

                    <tr v-if="isLastOfMaterial(estoque)" class="table-info">
                      <td colspan="4" class="text-center font-weight-bold">
                        <strong>Total:</strong>
                      </td>
                      <td class="text-center font-weight-bold">
                        <strong>
                          {{ getTotal(estoque.material_id, estoque) }}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="!estoques.length">
                    <tr>
                      <td colspan="5" class="text-center p-3">
                        <i class="fas fa-inbox fa-2x text-muted mb-2"></i>
                        <br />
                        Não há estoques para este material
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeModal">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isModalOpen" class="modal-backdrop fade show"></div>
      <div class="ibox-title" style="padding: 16px">
        <div class="modal fade" id="modalExport" tabindex="-1" role="dialog" aria-labelledby="modalExportTitle"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Exportar</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body mt-1">
                <div class="alert alert-warning" role="alert">
                  Para exportar todos os registros, basta não definir nenhum
                  intervalo de datas e proceder com a exportação.
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-1">
                    <label>Data de Ínicio</label>
                    <input type="date" class="form-control" v-model="filtros.data_inicio" />
                  </div>
                  <div class="col-md-6 mb-1">
                    <label>Data do Fim</label>
                    <input type="date" class="form-control" v-model="filtros.data_fim" />
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                  Fechar
                </button>
                <button type="button" class="btn btn-primary" @click="exportToExcel">
                  Exportar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      filtros: {
        data_inicio: null,
        data_fim: null,
      },
      table: "materiaisTable",
      isModalOpen: false,
      selectedApproval: { id: null },
      estoques: [],
      tabs: [],
      material: { nome: "" },
      grupos: [], // Lista de grupos para o filtro
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "nome",
        "grupo_id",
        "subgrupo_id",
        "familia_id",
        // "fabricante_id",
        // "fornecedor_id",
        "portaria",
        "dispensavel",
        "quantidade",
        "preco_medio",
        "grade",
        "codigo",
        "tab_id",
        "actions",
      ],
      tableData: [
        "id",
        "nome",
        "grupo_id",
        "subgrupo_id",
        "familia_id",
        // "fabricante_id",
        // "fornecedor_id",
        "portaria",
        "dispensavel",
        "quantidade",
        "preco_medio",
        "grade",
        "codigo",
        "tab_id",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "nome",
          "grupo_id",
          "subgrupo_id",
          "familia_id",
          // "fabricante_id",
          // "fornecedor_id",
          "portaria",
          "dispensavel",
          "grade",
          "codigo",
          "tab_id",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Material",
          grupo_id: "Grupo",
          subgrupo_id: "SubGrupo",
          familia_id: "Familia",
          // fabricante_id: "Fabricante",
          // fornecedor_id: "Fornecedor",
          // empresa_id: "Empresa",
          portaria: "Portaria 344/98",
          dispensavel: "Dispensável",
          preco_medio: "Preço Médio",
          grade: "Grade",
          codigo: "Codigo",
          tab_id: "Aba",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          grupo_id: [], // Será preenchido dinamicamente pelo carregarGrupos()
          portaria: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          tab_id: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          dispensavel: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
        },
        templates: {
          grupo_id: function (h, row, index) {
            return row.grupo ? row.grupo.nome : "Indisponível";
          },
          subgrupo_id: function (h, row, index) {
            return row.subgrupo ? row.subgrupo.nome : "Indisponível";
          },
          familia_id: function (h, row, index) {
            return row.familia ? row.familia.nome : "Indisponível";
          },
          empresa_id: function (h, row, index) {
            return row.empresa ? row.empresa.nome_fantasia : "Indisponível";
          },
          tab_id: function (h, row, index) {
            return row.tab ? row.tab.title : "Indisponível";
          },
          // fabricante_id: function (h, row, index) {
          //   return row.fabricante
          //     ? row.fabricante.nome_fantasia
          //     : "Indisponível";
          // },
          // fornecedor_id: function (h, row, index) {
          //   return row.fornecedor
          //     ? row.fornecedor.nome_fantasia
          //     : "Indisponível";
          // },
          codigo: function (h, row, index) {
            return row.codigo ? row.codigo : "Indisponível";
          },
          portaria: function (h, row, index) {
            return row.portaria === 1 ? (
              <h5>
                <span class="badge badge-danger">Sim</span>
              </h5> // Fecha o modal
            ) : (
              "Não"
            );
          },
          quantidade: function (h, row, index) {
            if (row.quantidade > row.estoque_minimo * 1.1) {
              return <span class="badge badge-success">{row.quantidade}</span>;
            }

            if (row.quantidade < row.estoque_minimo) {
              return <span class="badge badge-danger">{row.quantidade}</span>;
            }

            if (row.quantidade <= row.estoque_minimo * 1.1) {
              return <span class="badge badge-warning">{row.quantidade}</span>;
            }
          },
          preco_medio: function (h, row, index) {
            // Forçar reatividade usando $forceUpdate se necessário
            if (row.preco_medio !== null && row.preco_medio !== undefined) {
              return (
                <span class="badge badge-info">
                  R$ {parseFloat(row.preco_medio).toFixed(2)}
                </span>
              );
            } else {
              return <span class="badge badge-danger">Não calculado</span>;
            }
          },
          grade: function (h, row, index) {
            if (row.grade !== null && row.grade !== undefined) {
              return <span class="badge badge-success">{row.grade}</span>;
            } else {
              return <span class="badge badge-dark">Não informado</span>;
            }
          },
          dispensavel: function (h, row, index) {
            return (
              <h5>
                <span
                  class={
                    row.dispensavel === 1
                      ? "badge badge-success"
                      : "badge badge-danger"
                  }
                >
                  {row.dispensavel === 1 ? "Sim" : "Não"}
                </span>
              </h5>
            );
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [
            "grupo",
            "subgrupo",
            "familia",
            "tab",
            // "fabricante",
            // "fornecedor",
          ];

          return axios
            .get(this.url + "?" + query, requestData)
            .then((response) => {
              // Forçar reatividade dos dados usando $nextTick
              this.$nextTick(() => {
                if (response.data && response.data.data) {
                  // Garantir que preco_medio seja reativo
                  response.data.data.forEach((item, index) => {
                    if (item.preco_medio !== undefined) {
                      this.$set(response.data.data, index, { ...item });
                    }
                  });
                }
              });
              return response;
            })
            .catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
            );
        },
      },
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-crud check",
          title: "Verificar Estoque",
          name: "check",
          icon: "far fa-sticky-note",
        },
      ],
      endPoint: "materiais",
      grupos: [
        { id: 8, text: 'MED' },
        { id: 9, text: 'MAT' },
        { id: 10, text: 'EQUIP' },
        { id: 11, text: 'ADM' }
      ],
      gruposSelecionados: [],
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  mounted() {
    this.carregarGrupos();
    this.getAbas();

    // Abordagem mais simples: apenas força update depois que tudo carregou
    this.$nextTick(() => {
      setTimeout(() => {
        // Força update para garantir que preco_medio seja exibido
        this.$forceUpdate();
      }, 1500);
    });
  },
  // Removido o watcher problemático que causava erros
  methods: {
    exportToExcel() {
      const self = this;
      const dataInicio = self.filtros.data_inicio;
      const dataFim = self.filtros.data_fim;

      if (dataInicio || dataFim) {
        if (dataInicio && dataFim) {
          var url = `${self.$store.state.url}exportar_materiais?data_inicio=${dataInicio}&data_fim=${dataFim} 23:59:59`;
          window.open(url, "_blank").focus();
        } else {
          self.$message(
            null,
            "Por favor, preencha ambos os campos de data.",
            "error"
          );
          return;
        }
      } else {
        var url = `${self.$store.state.url}exportar_materiais`;
        window.open(url, "_blank").focus();
      }
    },
    carregarGrupos() {
      const self = this;
      const api = self.$store.state.api + 'grupos';

      console.log('Carregando grupos de:', api);

      axios.get(api)
        .then((response) => {
          console.log('Resposta grupos:', response.data);

          self.grupos = response.data.data.map((grupo) => ({
            id: grupo.id,
            text: grupo.nome,
          }));

          console.log('Grupos formatados:', self.grupos);
        })
        .catch((error) => {
          console.error('Erro ao carregar grupos:', error);

          // Adicionar dados de teste se der erro
          self.grupos = [
            { id: 8, text: 'MED' },
            { id: 9, text: 'MAT' },
            { id: 10, text: 'EQUIP' },
            { id: 11, text: 'ADM' }
          ];
          console.log('Usando dados de teste:', self.grupos);
        });
    },
    filtrarPorGrupos() {
      console.log('Filtros aplicados:', this.gruposSelecionados);
      // Força refresh da tabela
      if (this.$refs.materiaisCrud && this.$refs.materiaisCrud.$refs.table) {
        this.$refs.materiaisCrud.$refs.table.refresh();
      }
    },
    limparFiltros() {
      console.log('Limpando filtros...');
      this.gruposSelecionados = [];
      // Força refresh da tabela
      if (this.$refs.materiaisCrud && this.$refs.materiaisCrud.$refs.table) {
        this.$refs.materiaisCrud.$refs.table.refresh();
      }
    },
    isLastOfMaterial(estoque) {
      if (!estoque || typeof estoque.material_id === "undefined") {
        return false;
      }

      const index = this.estoques.indexOf(estoque);
      const nextEstoque = this.estoques[index + 1];

      // Último item do array
      if (index === this.estoques.length - 1) {
        return true;
      }

      // Próximo item é separador de vencidos (fim dos válidos)
      if (nextEstoque && nextEstoque.isVencidosSeparator) {
        return true;
      }

      // Próximo item é de outro material
      if (nextEstoque && nextEstoque.material_id !== estoque.material_id) {
        return true;
      }

      return false;
    },

    getTotal(materialId, currentEstoque) {
      if (!materialId) {
        return 0;
      }

      // Encontrar o índice do estoque atual
      const currentIndex = this.estoques.indexOf(currentEstoque);

      // Verificar se estamos na seção de vencidos
      const separatorIndex = this.estoques.findIndex(
        (e) => e.isVencidosSeparator
      );
      const isInVencidosSection =
        separatorIndex !== -1 && currentIndex > separatorIndex;

      if (isInVencidosSection) {
        // Somar TUDO (válidos + vencidos) - TOTAL GERAL
        return this.estoques
          .filter(
            (estoque) =>
              estoque.material_id === materialId && !estoque.isVencidosSeparator
          )
          .reduce((total, estoque) => total + estoque.quantidade, 0);
      } else {
        // Somar apenas os válidos (antes do separador)
        return this.estoques
          .filter(
            (estoque, idx) =>
              estoque.material_id === materialId &&
              !estoque.isVencidosSeparator &&
              (separatorIndex === -1 || idx < separatorIndex)
          )
          .reduce((total, estoque) => total + estoque.quantidade, 0);
      }
    },
    getAbas() {
      const self = this;
      self.$loading(true);
      const api =
        self.$store.state.api + "tabs?paginated=false&orderByAsc=title";

      axios
        .get(api)
        .then((response) => {
          var tabs = [];
          response.data.data.forEach((element) => {
            tabs.push({
              id: element.id,
              text: element.title,
            });
          });

          self.options.listColumns.tab_id = tabs;

          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getEstoques(id) {
      const self = this;
      self.$loading(true);
      const apiValidos =
        self.$store.state.api +
        "estoques?material_id=" +
        id +
        "&filtroQuantidade=maior_que_zero" +
        "&with[]=fabricante&with[]=material";

      const apiVencidos =
        self.$store.state.api +
        "estoques?material_id=" +
        id +
        "&apenas_vencidos=true" +
        "&filtroQuantidade=maior_que_zero" +
        "&with[]=fabricante&with[]=material";

      self.estoques = [];

      // Buscar estoques válidos e vencidos em paralelo
      Promise.all([axios.get(apiValidos), axios.get(apiVencidos)])
        .then(([responseValidos, responseVencidos]) => {
          // Adicionar estoques válidos
          self.estoques = responseValidos.data?.data || [];

          // Se houver vencidos, adicionar separador e os vencidos
          const vencidos = responseVencidos.data?.data || [];
          if (vencidos.length > 0) {
            // Adicionar linha separadora
            self.estoques.push({
              isVencidosSeparator: true,
              fabricante: { nome: "VENCIDOS" },
              lote: "",
              quantidade: vencidos.reduce((sum, e) => sum + e.quantidade, 0),
              validade: "",
            });

            // Adicionar estoques vencidos
            self.estoques = self.estoques.concat(
              vencidos.map((e) => ({
                ...e,
                isVencido: true,
              }))
            );
          }

          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response?.data || error.message, "error");
        });
    },
    // Método para forçar refresh dos dados e corrigir problemas de reatividade
    forceRefresh() {
      // Primeira tentativa: usar o método refresh do BaseCrud se existir
      if (
        this.$refs.materiaisCrud &&
        typeof this.$refs.materiaisCrud.refresh === "function"
      ) {
        this.$nextTick(() => {
          try {
            this.$refs.materiaisCrud.refresh();
          } catch (error) {
            console.warn("Erro ao executar refresh do BaseCrud:", error);
          }
        });
      }
      // Segunda tentativa: acessar a tabela interna do BaseCrud
      else if (
        this.$refs.materiaisCrud &&
        this.$refs.materiaisCrud.$refs &&
        this.$refs.materiaisCrud.$refs.table &&
        typeof this.$refs.materiaisCrud.$refs.table.refresh === "function"
      ) {
        this.$nextTick(() => {
          try {
            this.$refs.materiaisCrud.$refs.table.refresh();
          } catch (error) {
            console.warn("Erro ao executar refresh da tabela:", error);
          }
        });
      }
      // Fallback: força update do componente
      else {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }

      // Sempre força update adicional após um delay para garantir reatividade
      setTimeout(() => {
        this.$forceUpdate();
      }, 500);
    },
    // Método adicional para refresh manual quando necessário
    refreshData() {
      // Simples força update sem chamar forceRefresh para evitar loops
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    check(props) {
      this.openModal(props.row.id);
    },
    openModal(id) {
      this.getEstoques(id);
      this.selectedApproval.id = id;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    carregarGrupos() {
      const self = this;
      self.$loading(true);
      const api = self.$store.state.api + 'grupos';

      console.log('Carregando grupos da URL:', api);

      axios.get(api)
        .then((response) => {
          console.log('Resposta da API grupos:', response.data);

          var grupos = [];
          response.data.data.forEach((element) => {
            grupos.push({
              id: element.id,
              text: element.nome,
            });
          });

          console.log('Grupos formatados:', grupos);

          self.options.listColumns.grupo_id = grupos;

          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          console.error('Erro ao carregar grupos:', error);
          if (error.response && error.response.data) {
            self.$message(null, error.response.data, "error");
          } else {
            console.error('Erro ao carregar grupos:', error.message);
          }
        });
    },
    query: function (query) {
      console.log('Query recebida:', query);

      let columns = {
        id: "id",
        nome: "nome",
        grupo_id: "grupo_id",
        subgrupo_id: "subgrupo[nome]",
        familia_id: "familia[nome]",
        portaria: "portaria",
        dispensavel: "dispensavel",
        quantidade: "quantidade",
        grade: "grade",
        codigo: "codigo",
        tab_id: "tab_id",
      };

      let filters = "";

      // Adicionar filtro de grupos selecionados
      if (this.gruposSelecionados && this.gruposSelecionados.length > 0) {
        this.gruposSelecionados.forEach(grupo => {
          filters += `grupo_id[]=${grupo.id}&`;
        });
      }

      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      console.log('Filters construídos:', filters);
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}

/* Estilos para o modal de estoques */
.table-responsive {
  border-radius: 0.375rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.table-responsive::-webkit-scrollbar {
  height: 8px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.modal-xl {
  max-width: 90%;
  margin: 0 auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

@media (max-width: 768px) {
  .modal-xl {
    max-width: 95%;
    margin: 0.5rem auto;
  }

  .modal-dialog-centered {
    min-height: calc(100% - 1rem);
  }
}
</style>